import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/esm/Button";
import Card from "react-bootstrap/esm/Card";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import toast, { Toaster } from "react-hot-toast";
import BackToGameList from "../../utils/BackToGameList";

function ColorCount() {
  const [intervalID, setIntervalID] = useState();
  const [play, setPlay] = useState(false);
  const [gO, setGO] = useState(false);
  const [gameComplete, setGameComplete] = useState(false);
  const [time, setTime] = useState(60);
  const [buttons, setButtons] = useState([]);
  const [answer, setAnswer] = useState();
  const [incorrectCount, setIncorrectCount] = useState(0);

  const checkNumbers = () => {
    let blue = 0;
    let green = 0;
    let red = 0;
    let redA = [];
    let blueA = [];
    let greenA = [];
    let checkArray = [red, blue, green];
    let highestNumber = Math.max(red, blue, green);
    do {
      blue = Math.floor(Math.random() * 10) + 1;
      green = Math.floor(Math.random() * 10) + 1;
      red = Math.floor(Math.random() * 10) + 1;
      checkArray = [red, blue, green];
      highestNumber = Math.max(red, blue, green);
    } while (checkArray.filter((n) => n === highestNumber).length > 1);
    let correctColor = checkArray.findIndex((n) => n === highestNumber);
    setAnswer(correctColor);
    for (let i = 0; i < red; i++) {
      redA.push(
        <Button
          variant="danger"
          style={{ width: "100px", margin: "10px", height: "40px" }}
          key={Math.random()}
        >
          {" "}
        </Button>
      );
    }
    for (let i = 0; i < blue; i++) {
      blueA.push(
        <Button
          key={Math.random()}
          style={{ width: "100px", margin: "10px", height: "40px" }}
        >
          {" "}
        </Button>
      );
    }
    for (let i = 0; i < green; i++) {
      greenA.push(
        <Button
          variant="success"
          key={Math.random()}
          style={{ width: "100px", margin: "10px", height: "40px" }}
        >
          {" "}
        </Button>
      );
    }
    setButtons([
      ...redA.map((redButtons) => {
        return { value: redButtons, id: Math.random() };
      }),
      ...blueA.map((blueButtons) => {
        return { value: blueButtons, id: Math.random() };
      }),
      ...greenA.map((greenButtons) => {
        return { value: greenButtons, id: Math.random() };
      }),
    ]);
  };

  useEffect(() => {
    if (play) {
      const intervalId = setInterval(() => {
        if (play) {
          setTime((prevSeconds) => prevSeconds - 1);
        }
      }, 1000);
      setIntervalID(intervalId);
      return () => clearInterval(intervalId);
    }
  }, [play]);

  const startGame = () => {
    setPlay(true);
    setGO(false);
    setGameComplete(false);
    checkNumbers();
  };

  const gameOver = () => {
    setTime(60);
    setPlay(false);
    setGO(true);
  };

  useEffect(() => {
    if (time <= 0) {
      gameOver();
      setGameComplete(true);
    }
  }, [time]);

  const checkHighest = (c) => {
    let correctColor = "";
    if (answer === 0) {
      correctColor = "r";
    }
    if (answer === 1) {
      correctColor = "b";
    }
    if (answer === 2) {
      correctColor = "g";
    }
    if (correctColor === c) {
      setPlay(false);
      toast(
        "Congratulations, you've completed the game! Click the Restart button to do it all again. Number of incorrects: " +
          incorrectCount,
        {
          duration: 5000,
          position: "bottom-center",
        }
      );
      setGameComplete(true);
      setTime(60);
      setButtons([]);
    } else {
      toast("Sorry but that is incorrect. Please try again!", {
        duration: 5000,
        position: "bottom-center",
      });
      setIncorrectCount((prevCount) => prevCount + 1);
    }
  };

  return (
    <>
      <BackToGameList />
      {!play ? (
        <Card style={{ marginTop: "50px" }}>
          <Card.Header style={{ textAlign: "center", fontSize: "24px" }}>
            <b>Color Count</b>
          </Card.Header>
          <Card.Body style={{ textAlign: "center" }}>
            {gO
              ? `Looks like you ran out of time! Don't fret, to play again touch the Restart Game button below. Select the color that appears the most times to win!`
              : !gameComplete
              ? `To play touch the Start Game button below. Select the color that appears the most times to win!`
              : `Congratulations, you've found the Color Count! To play again touch the Restart Game button below. Select the color that appears the most times to win!`}
            <br />
            <Button onClick={startGame}>
              {!gameComplete ? "Start Game" : "Restart Game"}
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <Card style={{ marginTop: "50px" }}>
          <Row>
            <Col style={{ textAlign: "center" }}>Time Remaining: {time}</Col>
          </Row>
          <Row>
            {buttons
              .sort((a, b) => a.id - b.id)
              .map((n) => {
                return (
                  <Col key={n.id} style={{ textAlign: "center" }}>
                    {n.value}
                  </Col>
                );
              })}
          </Row>
          <Row style={{ marginTop: "25px" }}>
            <h3 style={{ textAlign: "center" }}>
              Select the Color below that appears the most times:
            </h3>
          </Row>
          <Row
            style={{
              marginLeft: "25px",
              marginRight: "25px",
              marginBottom: "25px",
            }}
          >
            <Col style={{ textAlign: "center" }}>
              <Button
                variant="danger"
                style={{ width: "100%", height: "50px", fontSize: "24px" }}
                onClick={() => checkHighest("r")}
              >
                Red
              </Button>
            </Col>
            <Col style={{ textAlign: "center" }}>
              <Button
                style={{ width: "100%", height: "50px", fontSize: "24px" }}
                onClick={() => checkHighest("b")}
              >
                Blue
              </Button>
            </Col>
            <Col style={{ textAlign: "center" }}>
              <Button
                style={{ width: "100%", height: "50px", fontSize: "24px" }}
                variant="success"
                onClick={() => checkHighest("g")}
              >
                Green
              </Button>
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
}

export default ColorCount;
